import React from 'react';
import styles from './GuaranteePoints.module.scss';
import Guarantee from '../guarantee';
import LazyImage from 'gui/components/LazyImage/LazyImage';

interface IGuaranteePointsProps {
  className?: string;
}

const GuaranteePoints = (props: IGuaranteePointsProps) => {

  return (
    <div className={`guaranteePoints ${styles.guaranteePoints} ${props.className}`.trim()}>
      <div className='points'>
        <Guarantee iconComponent={<LazyImage src={'/img/guranteeOkCircle.png'} title={'ok'}/>}>
          עסקה בטוחה
        </Guarantee>
        <div className={styles.verticalDivider}/>
        <Guarantee iconComponent={<LazyImage src={'/img/guranteeDollarCircle.png'} title={'dollar'}/>}>
          תשלום מאובטח
        </Guarantee>
        <div className={styles.verticalDivider}/>
        <Guarantee iconComponent={<LazyImage src={'/img/guranteeSupport.png'}
                                             title={'support'}/>}>
          פה בשבילכם בכל שלב
        </Guarantee>
      </div>
      <div className={styles.horizontalDivider}/>
    </div>
  );
};

GuaranteePoints.defaultProps = {
  className: '',
};

export default React.memo(GuaranteePoints);
